module.exports = __webpack_public_path__ + "img/elovate_users_crop.6d144828.png";